export default __webpack_public_path__ + "static/media/Wearable Diagnostics.fe2ebc61.png";